<template>
  <el-tag
      ref="gjTag"
      v-bind="$attrs"
      v-on="$listeners"
      :size="mapSize"
      :closable="closable"
      :class="{'gj-tag': true, 'gj-tag--oval': shape === 'oval', 'gj-tag--text': type === 'text'}"
      :style="[colorStyle]"
      >
    <slot></slot>
  </el-tag>
</template>

<script>
  import {isType} from '@/utils/common.js'
  const mapSize = {
    default: 'mini',
  };
  
  export default {
    name: "gj-tag",
    props: {
      size: {
        type: String,
        default: 'default',
      },
      type: {
        type: String,
        default: 'dark', // dark 底部填充、白字；plain 线性 浅色填充
        validator: function (value) {
          return ['dark', 'plain', 'text'].indexOf(value) !== -1
        }
      },
      shape: {
        type: String,
        default: 'oval', // 形状：椭圆形、长方形
        validator: function (value) {
          return ['oval', 'rectangle'].indexOf(value) !== -1
        }
      },
      color: {
        type: String | Object,
        required: false,
        default: '#1F6EEF',
      },
      closable:{
        type:Boolean,
        default:false
      },
    },
    computed: {
      mapSize() {
        return mapSize[this.size] || this.size;
      },
      colorStyle() {
        let color, bdColor, bgColor
        if (isType(this.color, 'Object')) {
          color = this.color.color ?? '#333'
          bgColor = this.color.bgColor
          bdColor = this.color.bdColor ?? this.color.color
        } else {
          color = this.color
        }
        switch (this.type) {
          case 'dark':
            return {
              backgroundColor: bgColor ?? color,
              color: bgColor ? color : '#fff',
              border: 'none',
              'line-height':'22px',
              // 'border-radius': '6px',
              // padding: '0 8px'
            };
          case 'plain':
            return {
              borderColor: bdColor,
              color: color,
              backgroundColor: bgColor ?? `#fff`
            };
          case 'text':
            return {
              color: color
            };
          default:
            return {};
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.gj-tag{
  line-height:20px;
  font-weight: 400;
  border-radius: 6px;
}
  .gj-tag--oval {
    margin-right: 4px;
  }
  .gj-tag--text {
    background: unset;
    border: none;
    padding: 0;
    height: unset;
    margin: 0;
  }
</style>
